import { apiConfig } from "@/api/AppApi/config";
import ApiUpload from "./api-upload";
import { IUploadImageRes } from "./interfaces/IUpload";
import { useMutation } from "@tanstack/react-query";

const uploadConfig = () => {
  let config = apiConfig("en");
  config.headers["Content-Type"] = "multipart/form-data;boundary=x-x"; //; boundary=x
  // config.Accept = "application/json";
  return config;
};
export const useUpload = () => new ApiUpload(uploadConfig());
export const useUploadImage = ({
  onSuccess,
  onError,
}: {
  onSuccess: (res: IUploadImageRes) => void;
  onError: (x: any) => void;
}) => {
  const upload = useUpload();
  return useMutation(upload.imageUpload, {
    onSuccess: onSuccess,
    onError: onError,
  });
};
export const useUploadFile = ({
  onSuccess,
  onError,
}: {
  onSuccess: (res: IUploadImageRes) => void;
  onError: (x: any) => void;
}) => {
  const upload = useUpload();
  return useMutation(upload.fileUpload, {
    onSuccess: onSuccess,
    onError: onError,
  });
};
export const useUploadAudio = ({
  onSuccess,
  onError,
}: {
  onSuccess: (res: IUploadImageRes) => void;
  onError: (x: any) => void;
}) => {
  const upload = useUpload();
  return useMutation(upload.audioUpload, {
    onSuccess: onSuccess,
    onError: onError,
  });
};
